export const environment = {
  production: false,
  apiUrl: 'https://tools-test.adcore.com/api'
};
